
export let playBtn = () => `<a href="" role="button" class="controlbar-button">${require('../../../svg/player-play.svg')}</a>`;

export let pauseBtn = () => `<a style="display: none;" href="" role="button" class="controlbar-button">${require('../../../svg/player-pause.svg')}</a>`;